import React, { FormEvent, MouseEvent, useEffect, useState } from 'react';
import { Button, InputAdornment, styled, TextField } from '@mui/material';
import Dialog from 'components/dialogs/Dialog';
import { PackageProduct } from 'types/package';
import { Product } from 'types/product';
import { toast } from 'react-toastify';
import ProductsAutoComplete from 'components/autocomplete/ProductsAutoComplete';

interface PackageProductFormProps {
  onExited: () => void;
  handleAddProduct: (productInfo: PackageProduct | null) => void;
  productInfo: PackageProduct | null;
  // a quantidade é texto digitado, por isso o valor também pode ser string
  handleChangeProductInfo<K extends keyof PackageProduct>(index: K, value: PackageProduct[K] | string): void;
  type: 'new' | 'edit';
}

const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  columnGap: 10,
  rowGap: 15,
});

const DialogActions = styled('div')({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
});

const PackageProductForm: React.FC<PackageProductFormProps> = ({
  handleAddProduct,
  onExited,
  productInfo,
  handleChangeProductInfo,
  type,
}) => {
  const [product, setProduct] = useState<Product | null>(null);

  useEffect(() => {
    setProduct(productInfo?.product || null);
  }, [productInfo]);

  function handleValidation(e?: MouseEvent<HTMLButtonElement>) {
    e?.preventDefault();

    if (!product || !productInfo?.product_id) {
      toast.error('Selecione um produto');
      return;
    }

    if (!productInfo.quantity) {
      toast.error('Informe a quantidade');
      return;
    }

    handleAddProduct({
      ...productInfo,
      product: product,
      product_id: product.id,
    });
  }
  return (
    <Dialog
      onExited={onExited}
      disableEscapeKeyDown
      disableBackdropClick
      maxWidth="sm"
      title={type === 'edit' ? 'Editar produto' : 'Adicionar produto'}
    >
      <Container>
        <ProductsAutoComplete
          label="Produto"
          onSelect={product => {
            handleChangeProductInfo('product_id', product?.id || 0);
            handleChangeProductInfo('product', product);
            setProduct(product);
          }}
          placeholder="Selecione um produto"
          selected={product}
        />

        <TextField
          label="Quantidade"
          placeholder="Digite a quantidade"
          value={productInfo?.quantity || ''}
          onChange={e => handleChangeProductInfo('quantity', e.target.value)}
          fullWidth
          slotProps={{
            input: {
              endAdornment: <InputAdornment position="end">{productInfo?.product?.unit}</InputAdornment>,
            },
          }}
        />

        <DialogActions>
          <Button variant="outlined" color="primary" onClick={onExited}>
            Cancelar
          </Button>
          <Button variant="contained" color="primary" onClick={handleValidation}>
            {type === 'new' ? 'Adicionar' : 'Salvar'}
          </Button>
        </DialogActions>
      </Container>
    </Dialog>
  );
};

export default PackageProductForm;
